export default __webpack_public_path__ + "static/media/Snd4.4b53891c.mp3";